import { useSelector } from 'react-redux';

import { StyledPagination } from '@labradorsports/components';
import { useSite } from '@labradorsports/utils';

import { useDispatcher } from '../../shared/index.js';
import { RouterSelectors, routerActions } from '../../store/index.js';

interface Props {
    useHref?: boolean;
    numPages: number;
}

const CommunityPagination: FC<Props> = ({ useHref, numPages }) => {
    const { env } = useSite();
    const openCommunityPage = useDispatcher(routerActions.OpenPage);
    const pageNumber = useSelector(RouterSelectors.communityPageNumber);

    const getPageHref = (page: number) => {
        return `${env.baseUrl}/community?pg=${page}`;
    };

    return (
        <StyledPagination
            getHref={useHref ? getPageHref : null}
            count={numPages}
            page={pageNumber}
            onChange={openCommunityPage}
        />
    );
};

export default CommunityPagination;
